export default class EmployerPriceCategoryFactory {
  create() {
    return {
      id: null,
      status: null,
      company_id: null,
      title: null,
      percent: null,
    }
  }
}
